import React from 'react';
import { Send } from 'lucide-react';
import styles from '../SocialContact.module.css';
import type { contactInfo } from '../types.props';

interface contactCardProps {
    contact: contactInfo;
    onClick: (type: contactInfo['type'], value: string) => void;
}

export const ContactCard: React.FC<contactCardProps> = ({ contact, onClick }) => {
    const IconComponent = contact.icon;

    return (
        <article
            className={styles["card-base"]}
            data-color-class={contact.colorClass}
            onClick={() => onClick(contact.type, contact.value)}
            role="button"
            tabIndex={0}
            aria-label={`Contactar por ${contact.label}: ${contact.value}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(contact.type, contact.value);
                }
            }}
        >
            <div className={styles["social-card-content"]}>
                <div className={styles["icon-wrapper"]} data-color-class={contact.colorClass}>
                    <IconComponent size={32} color="#ffffff" />
                </div>
                <h3 className={styles["card-title"]}>{contact.label}</h3>
                <p className={styles["card-username"]} style={{ wordBreak: 'break-all' }}>
                    {contact.value}
                </p>
                <div className={styles["external-icon"]}>
                    <Send size={20} />
                </div>
            </div>
            <div className={styles.overlay} />
        </article>
    );
};
